import { useState, useEffect } from 'react';
import API from '../api/axios';

// Focusly AI availability is a property of the deployment, not of the user, so
// the answer is identical for everyone and is fetched once per page load. The
// promise (not the value) is cached so that simultaneous first callers share a
// single request rather than racing three of them.
let statusPromise = null;

function fetchStatus() {
  if (!statusPromise) {
    statusPromise = API.get('/ai/status')
      .then(({ data }) => Boolean(data?.enabled))
      // An unconfigured or unreachable backend means the feature is not
      // available -- fail closed rather than advertising a page that 500s.
      .catch(() => false);
  }
  return statusPromise;
}

// Exposed for tests and for the logout path: the next login re-asks the server.
export function resetAiStatusCache() {
  statusPromise = null;
}

export default function useAiStatus() {
  const [state, setState] = useState({ aiEnabled: false, loaded: false });

  useEffect(() => {
    let cancelled = false;
    fetchStatus().then((aiEnabled) => {
      if (!cancelled) setState({ aiEnabled, loaded: true });
    });
    return () => { cancelled = true; };
  }, []);

  return state;
}
